export enum ZoneResolutions {
  HD = 'PREVIEW_HD',
  HD_PORTRAIT = 'HD_PORTRAIT',
  FULL_HD = 'PREVIEW_FULL_HD',
  LEGACY = 'PREVIEW_LEGACY',
  TABLET_PC = 'PREVIEW_TABLET',
  TABLET_PORTRAIT = 'TABLET_PORTRAIT',
  CUSTOMIZE = 'CUSTOMIZE',
}
